import { SettingsSubModule } from '../utils/settings-sub-module';
import { SettingValue } from '../utils/setting-value';
import { SettingsModule } from '../utils/settings-module';

export namespace TranslationFields {
  export enum GeneralConfigFields {
    Enabled = 'Transport.Enabled',
    Organization = 'Transport.Organization',
    Department = 'Transport.Department',
    CertificateDocumentType = 'Transport.CertificateDocumentType',
  }
}

class GeneralConfig extends SettingsSubModule {
  @SettingsSubModule.value(TranslationFields.GeneralConfigFields.Enabled, false) enabled: SettingValue<boolean>;
  @SettingsSubModule.value(TranslationFields.GeneralConfigFields.Organization, '') organization: SettingValue<string>;
  @SettingsSubModule.value(TranslationFields.GeneralConfigFields.Department, '') department: SettingValue<string>;
  @SettingsSubModule.value(TranslationFields.GeneralConfigFields.CertificateDocumentType, null)
  certificateDocumentType: SettingValue<number>;
}

export class TranslationsModule extends SettingsModule {
  @SettingsModule.value(GeneralConfig) general: GeneralConfig;
}
